import _typeof from "@babel/runtime/helpers/typeof";
import { bind } from 'bind-event-listener';
import { withProfiling } from '../self-measurements';
var shouldInitilizeGlobalErrorHandler = true;
var globalCount = 0;
var errors = [];
var push = withProfiling(function push(name, labelStack, errorType, errorMessage, errorStack) {
  errors.push({
    name: name,
    labelStack: labelStack,
    errorType: errorType,
    errorMessage: errorMessage,
    errorStack: errorStack
  });
});
export var sinkErrorHandler = withProfiling(function sinkErrorHandler(sinkFunc) {
  push = withProfiling(sinkFunc);
  errors.forEach(function (e) {
    sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
  });
  errors.length = 0;
});
export var getGlobalErrorCount = withProfiling(function getGlobalErrorCount() {
  return globalCount;
});
var handleError = withProfiling(function handleError(e) {
  var _e$error;
  globalCount++;
  if (((_e$error = e.error) === null || _e$error === void 0 ? void 0 : _e$error.UFOhasCaught) === undefined) {
    try {
      if (e.error instanceof Error) {
        push('GlobalErrorHandler', null, e.error.name, e.error.message, e.error.stack);
      } else if (e.error) {
        var hint = JSON.stringify(e.error).slice(0, 50);
        push('GlobalErrorHandler', null, '', "Non error object thrown: ".concat(hint), undefined);
      } else if (e.message !== undefined) {
        var _hint = e.message.slice(0, 50);
        push('GlobalErrorHandler', null, '', "Non error object thrown: ".concat(_hint), undefined);
      }
      if (e.error && _typeof(e.error) === 'object') {
        e.error.UFOhasCaught = true;
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }
});
var handlePromiseRejection = withProfiling(function handlePromiseRejection(e) {
  globalCount++;
  if (e.reason instanceof Error) {
    push('GlobalErrorHandler', null, e.reason.name, e.reason.message, e.reason.stack);
  } else if (e.reason) {
    try {
      var hint = JSON.stringify(e.reason).slice(0, 50);
      push('GlobalErrorHandler', null, '', "Non error object thrown: ".concat(hint), undefined);
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }
});
var setupUFOGlobalErrorHandler = withProfiling(function setupUFOGlobalErrorHandler() {
  if (shouldInitilizeGlobalErrorHandler) {
    bind(window, {
      type: 'error',
      listener: function listener(e) {
        return handleError(e);
      }
    });
    bind(window, {
      type: 'unhandledrejection',
      listener: handlePromiseRejection
    });
    shouldInitilizeGlobalErrorHandler = false;
  }
});
export default setupUFOGlobalErrorHandler;